export const candidateSkillOptions = [
  "Abuse, Understanding",
  "Autism, Understanding",
  "Awareness of mental health, dementia and learning disability",
  "Basic First Aid",
  "Basic life support",
  "Breakaway Techniques",
  "Business Insurance",
  "Care Certificate",
  "Caring for dying person /Dying, death and bereavement",
  "CERTIFICATES",
  "CHALLENGING BEHAVIOR",
  "Child Safeguarding",
  "Code of Conduct",
  "Communication",
  "Confidentiality",
  "Continence care/Pressure area care",
  "COVID-19",
  "Cyber Security",
  "Dementia",
  "Diabetic Awareness",
  "Dignity and Respect",
  "Duty of care",
  "EFFECTIVE COMMUNICATION",
  "Epilepsy",
  "Equality and Diversity",
  "Fire awareness",
  "Fire Evacuation",
  "Fire Safety",
  "first aid Awareness at work",
  "First Aid Basic Life Support",
  "fluids and nutrition",
  "Food Hygiene",
  "GDPR",
  "Handling information",
  "Health and Safety",
  "Health and Safety Policy",
  "Health and social care",
  "Medication Policy",
  "Medication Training",
  "Mental Capacity Assessment",
  "MOVING AND HANDLING",
  "Non-Reponse",
  "Numeracy and Literacy",
  "Nutrition and Health",
  "NVQ 2",
  "NVQ 3",
  "Oral Health",
  "Palliative Care",
  "Person Centred Planning",
  "personal development",
  "PRESSURE CARE",
  "Privacy and dignity",
  "Record keeping",
  "recording",
  "ROLE OF CARE WORKER",
  "Safe Guarding Adults",
  "Safe Guarding Children",
  "Safe Guarding Policy",
  "Safeguarding (Level 1)",
  "Safeguarding (Level 2)",
  "Safeguarding (Level 3)",
  "Safeguarding (Level 4)",
  "Safeguarding Children",
  "safeguarding-recognizing adult abuse",
  "Skill1",
  "Stroke training",
  "Training plan",
  "Understand your role",
  "Work in a person-centred way",
  "Your personal development",
];
